import SkeletonColor from "../components/skeleton";

import React, {
  useEffect,
  useState,
  createContext,
  useContext,
  ReactNode,
} from "react";
import { useParams } from "react-router-dom";

export type ContextData = {
  invoiceData: {
    payable_amount: string;
    customerName: string;
    customerMobile: string;
    invoiceId: string;
    merchant_logo: string;
    merchant_name_logo: string;
    template_id: number;
    order_id: string;
    transaction_id: string;
    settlement_time: string;
    txn_status: string;
    vendor_name: string;
    vendor_email: string;
    vendor_number: string;
    bg_color?: string;
    vpa_collection?: boolean;
  } | null;
  loading: boolean;
  // added for upi url payment
  urlData: string;
  isSelected: boolean;
  toggleSelected: () => void;
};

export const FirstModuleContext = createContext<ContextData>({
  invoiceData: null,
  loading: true,
  // added later
  urlData: "",
  // added much later

  isSelected: false,
  toggleSelected: () => {},
});

type FirstModuleProviderProps = {
  children: ReactNode;
};

export const FirstModuleProvider: React.FC<FirstModuleProviderProps> = ({
  children,
}) => {
  const [invoiceData, setInvoiceData] =
    useState<ContextData["invoiceData"]>(null);
  const [loading, setLoading] = useState(true);
  const [urlData, setUrlData] = useState("");
  const [isSelected, setSelected] = useState(false);
  // const urlParams = window.location.pathname;
  // const urlParamsString = urlParams?.split("/");
  // const invoiceId = urlParamsString?.[urlParamsString.length - 1];
  const { dynamicData } = useParams();
  // console.log(dynamicData, "id");

  const toggleSelected = () => {
    setSelected(true);
    // console.log("toggle");
  };

  useEffect(() => {
    const fetchData = async () => {
      // const urlParams = "https://vampay.in/Merchant/pin/ba4gMu";
      // const urlParamsString = urlParams.split("/");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/Merchent/merchantCreateInvoice`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              invoice_id: dynamicData,
            }),
          },
        );

        if (!response.ok) {
          throw new Error("API request failed Error fetching Invoice");
        }

        const data = await response.json();
        setInvoiceData(data.data);
        updateMetaTags(data?.data?.vendor_name);
        if (data.data.error_message) {
          alert(data?.message || "Incorrect Url");
          throw new Error(data?.message || "Incorrect Url");
        } else {
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();

    dynamicData && setUrlData(dynamicData);
  }, [dynamicData]);

  // console.log("urlParams", urlParams);
  // console.log(loading, "==>loading");

  const updateMetaTags = (description: string) => {
    document
      .querySelector('meta[name="Vampay"]')
      ?.setAttribute(
        "content",
        `Quick heads up! Just a reminder to send your payment to ${description}. Here's the link.`,
      );
    // You can add more meta tags update logic here if needed
  };

  return (
    <FirstModuleContext.Provider
      value={{ invoiceData, loading, urlData, isSelected, toggleSelected }}
    >
      {loading && <SkeletonColor />}
      {!loading && children}
      {/* {error && <div>{error}</div>} */}
    </FirstModuleContext.Provider>
  );
};

export const useFirstModule = () => {
  return useContext(FirstModuleContext);
};
